module.exports = __webpack_public_path__ + "static/media/4342.c9247dbe.jpg";